import CryptoJS from 'crypto-js';

const crpytoConfig = {
  AES_KEY: CryptoJS.enc.Utf8.parse('1234123412ABCDEF'),
  AES_IV: CryptoJS.enc.Utf8.parse('ABCDEF1234123412'),
  API_KEY:  CryptoJS.enc.Utf8.parse('SDWAN-ENCRYPTPWD')
};

/**
 * @description aes加密 Hash (前端本地存储用)
 * @param {string} word 需要加密的字符串
 */

export const cryptoEncrypt = word => {
  const { AES_IV, AES_KEY } = crpytoConfig;

  let srcs = CryptoJS.enc.Utf8.parse(word);
  let encrypted = CryptoJS.AES.encrypt(srcs, AES_KEY, { iv: AES_IV, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });

  return encrypted.ciphertext.toString().toUpperCase();
};


/**
 * @description aes解密 Hash (前端本地存储用)
 * @param {string} word 需要解密的字符串
 */

export const cryptoDecrypt = word => {
  const { AES_IV, AES_KEY } = crpytoConfig;

  let encryptedHexStr = CryptoJS.enc.Hex.parse(word);
  let srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
  let decrypt = CryptoJS.AES.decrypt(srcs, AES_KEY, { iv: AES_IV, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
  let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);

  return decryptedStr.toString();
}



/**
 * @description aes加密 Base64 （后端对接用）
 * @param {string} word 需要加密的字符串
 */
export const cryptoEncryptBase = word => {
  const { API_KEY } = crpytoConfig;

  let srcs = CryptoJS.enc.Utf8.parse(word);
  let encrypted = CryptoJS.AES.encrypt(srcs, API_KEY, { mode: CryptoJS.mode.ECB, });

  let ciphertextBase64 = CryptoJS.enc.Base64.stringify(encrypted.ciphertext);

  return ciphertextBase64;
};


/**
 * @description aes解密 Base64 （后端对接用）
 * @param {string} word 需要解密的字符串
 */

export const cryptoDecryptBase = word => {
  if (!word) return '';
  
  const { API_KEY } = crpytoConfig;

  let ciphertext = CryptoJS.enc.Base64.parse(word);

  let decrypted = CryptoJS.AES.decrypt(
    { ciphertext: ciphertext },
    API_KEY,
    { mode: CryptoJS.mode.ECB }
  );

  let decryptedText = CryptoJS.enc.Utf8.stringify(decrypted);

  return decryptedText;
}
